import { AxiosResponse } from 'axios';
import { ReactNode } from 'react';
import { ValueOf } from 'types/custom';

// Sanitized doctor row from GET /auth/me. Locale-map jsonb fields
// (first_name/last_name) are read via pickLocale at the callsites, so they
// are left loose here.
export type DoctorUser = {
  id: string | number | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  first_name: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  last_name: any;
  email: string;
  avatar: string | null;
  phone: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settings: any | null;
  timezone: string | null;
};

export const ActionTypes = {
  SIGN_OUT: 'SIGN_OUT',
  SET_USER: 'SET_USER',
  SET_BLOCKED_VISIBLE: 'SET_BLOCKED_VISIBLE',
  SET_LOADING: 'SET_LOADING',
  SET_TMP_TOKEN: 'SET_TMP_TOKEN',
  SET_REDIRECT_PATH: 'SET_REDIRECT_PATH'
} as const;

export type LoginForm = {
  email: string;
  password: string;
};

export interface IAuthProps {
  children: ReactNode;
}

export type Action = {
  type: ValueOf<typeof ActionTypes>;
  data?: LoginForm | boolean | string | DoctorUser;
};

export type State = {
  from: string;
  phone: string;
  email: string;
  isBlockedVisible: boolean;
  tmpToken: string;
  redirectPath: string;
  isLoading: boolean;
  user: DoctorUser | null;
};

export type SignInReturnType = {
  redirectUrl: string;
  verified?: boolean;
  auth2fa?: boolean;
  accessToken?: string;
  email?: string;
  phone?: string;
  settings: {
    auth2fa: boolean;
  };
  tmpToken: string;
  refreshToken: string;
};

export type DispatchContext = {
  signOut: () => void;
  signIn: (data: LoginForm) => Promise<SignInReturnType>;
  verify: (key: string) => Promise<void>;
  forgot: (email: string) => Promise<void>;
  setPassword: (password: string, key: string) => Promise<void>;
  verifyEmail: (email: string, code: string) => Promise<void>;
  verifyPhone: (phone: string, code: string) => Promise<void>;
  setRedirectUrl: (data: string) => void;
  verify2FA: (
    otp: string,
    tmpToken: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<AxiosResponse<any, any>>;
  getUserData(): void;
  refetchUserData(): void;
};

export type Dispatch = (action: Action) => void;
